import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

type ThemeMode = 'light' | 'dark' | 'system';

interface AppState {
  ui: {
    loading: boolean;
    themeMode: ThemeMode;
  };
  setLoading: (loading: boolean) => void;
  setThemeMode: (mode: ThemeMode) => void;
}

export const useAppStore = create<AppState>()(
  devtools(
    persist(
      (set) => ({
        ui: {
          loading: false,
          themeMode: 'dark',
        },
        setLoading: (loading) => set((state) => ({ ui: { ...state.ui, loading } })),
        setThemeMode: (mode) => set((state) => ({ ui: { ...state.ui, themeMode: mode } })),
      }),
      {
        name: 'app-storage',
        partialize: (state) => ({ ui: { themeMode: state.ui.themeMode } }),
      }
    )
  )
);

// 重新導出認證 store
export { useAuthStore } from './authStore';
